import React from "react";

import { systemSetupPermissionSet } from "helpers";
import { useAgentOfficeSearchQuery } from "queries";

import { agentOfficeResultItem } from "../resultItems";

import AgentOfficeIcon from "static/images/agent-office.png";

const agentOfficeSection = () => {
	return {
		name: "agentOffices",
		title: "Agent Office",
		useSearchQuery: useAgentOfficeSearchQuery,
		renderItem: agentOfficeResultItem,
		getIcon: () => (
			<img src={AgentOfficeIcon} alt="" style={{ width: 23 }} />
		),
		getLink: ({ id }) =>
			`/system-setup/agent-office-setup/edit-agent-office/${id}`,
		requiredPermissions: systemSetupPermissionSet,
	};
};

export default agentOfficeSection;
